export const INVOICES_LIMIT = 20;
export const __FEATURE_LIMITS = 'LIMITS';
export const __FEATURE_BUNDLE_LIMITS_FA = 'LIMITS_FA';
export const __FEATURE_BUNDLE_LIMITS_AUTOBOOST = 'LIMITS_AUTOBOOST';
export const __FEATURE_AD_UPGRADE = 'FA';
export const __FEATURE_BTT = 'BTT';
export const __FEATURE_SPOTLIGHT = 'SPOTLIGHT';
export const __FEATURE_AUTO_BOOST = 'AUTOBOOST';
export const __FEATURE_MULTI_LOCATION = 'ML_LIMIT';
export const __FEATURE_ALL = 'ALL';
export const __FEATURE_USER_PREMIUM = 'USER_PREMIUM';
export const __FEATURE_TYPE_LIMITS_FA = 'limit_fa';
export const __FEATURE_TYPE_LIMITS_BOOST = 'limit_boost';
export const __FEATURE_TYPE_LIMITS_AUTOBOOST = 'limit_autoboost';
export const __FEATURE_TYPE_LIMIT = 'limit';
export const __FEATURE_TYPE_MULTI_LOCATION = 'ml_limit';
export const __FEATURE_TYPE_BOOST = 'boost';
export const __FEATURE_HIGHLIGHT = 'highlight';
export const __FEATURE_TYPE_BTT = 'btt';
export const __FEATURE_TYPE_AUTOBOOST = 'autoboost';
export const __FEATURE_TYPE_AUTOBOOST_AD = 'autoboost_ad';
export const __FEATURE_TYPE_FREE = 'free';
export const __FEATURE_TYPE_PREMIUM = 'PREMIUM';
export const __FEATURE_TYPE_UNLIMITED = 'unlimited';
export const __FEATURE_TYPE_FA = 'fa';
export const __FEATURE_TYPE_SPOTLIGHT = 'spotlight';
export const __FEATURE_TYPE_DISCOUNT_TAG = 'discount_tag';
export const __FEATURE_DISCOUNT_TAG = 'DISCOUNT_TAG';
export const __USER_PACKAGE = 'user_package';
export const __COUNTRY = 'COUNTRY';
export const __CITY = 'CITY';
export const __RADIX_DECIMAL = 10;
export const __ORIGIN_PACKAGE = 'package';
export const __ORIGIN_PAYMENT = 'payment';
export const __CART_PKG_QUANTITY_MAX = 5;
export const __CART_PKG_QUANTITY_MIN = 0;
export const __CHECKOUT_PKG_QUANTITY_MIN = 1;
export const __CHECKOUT_PKG_QUANTITY_MAX = 5;
export const __MONET_TRANSITION_PARAMS = 'monetTransParams';
export const __APPPLIED_COUPON = 'appliedCoupon';
export const __MONET_MULTI_CHECKOUT_PACKAGES = 'monetPkgSelected';
export const __SELECTED_PACKAGE = 'pkgSeleced';
export const __CONSUME_AFTER_PURCHASE = 'needConsumeAfterPurchase';
export const __PKG_PAYMENT_ORIGIN = 'pkgPaymentOrigin';
export const __FEATURE_TYPES_FROM_TRANSITION = ['limit', 'limit_fa', 'limit_boost', 'limit_autoboost', 'boost', 'ALL', 'btt', 'autoboost', 'autoboost_ad', 'fa', __FEATURE_TYPE_MULTI_LOCATION, __FEATURE_TYPE_SPOTLIGHT, __FEATURE_TYPE_DISCOUNT_TAG];
export const __PRODUCT_TYPE_MAP = {
    BTT: 'btt',
    LIMITS: 'limit',
    FA: 'fa',
    AUTOBOOST: 'autoboost',
    LIMITS_FA: 'limit_fa',
    LIMITS_AUTOBOOST: 'limit_autoboost',
    btt: 'btt',
    boost: 'boost',
    [__FEATURE_MULTI_LOCATION]: __FEATURE_TYPE_MULTI_LOCATION,
    ALL: 'ALL',
    [__FEATURE_DISCOUNT_TAG]: __FEATURE_TYPE_DISCOUNT_TAG
};
export const __TRACK_PRODUCT_TYPE_MAP = {
    LIMITS: 'limits',
    FA: 'upgrade_ad',
    LIMITS_FA: 'limit_fa',
    LIMITS_AUTOBOOST: 'limit_autoboost',
    ALL: 'all',
    [__FEATURE_MULTI_LOCATION]: __FEATURE_TYPE_MULTI_LOCATION
};
export const __FEATURE_TYPE_MAP = {
    limit: 'LIMITS',
    boost: 'FA',
    btt: 'FA',
    limits_discount_tag: 'LIMITS_DISCOUNT_TAG'
};

export const __BUSINESS_USER = 'BUSINESS';
export const __ADDITIONAL_NON_EDIT_FIELDS = ['type', 'vatNumber'];
export const __GST_FIELD_NAME = 'vatNumber';
export const __ACTIVE = 'active';
export const __SCHEDULED = 'scheduled';
export const __EXPIRED = 'expired';
export const __PACKAGE_TYPE_SINGLE = 'SINGLE';
export const __PACKAGE_TYPE_COMBO = 'COMBO';
export const __PACKAGE_TYPE_INDIVIDUAL = 'INDIVIDUAL';
export const __PACKAGE_TYPE_BUNDLE = 'BUNDLE';
export const __PACKAGE_POPUP_STATE = 'p_popup';
export const __PACKAGE_POPUP_STATE_DATE = 'p_popup_date';
export const __FLASHSALE_UNAVAILABLE_POPUP = 'flash_popup';

export const EXPERIMENT_BUSINESS_PACKAGE_PURCHASE = {
    BUSINESS_PACKAGE_PURCHASE: 'Bundling-Revamp-PWA'
};

export const DEEPLINK = 'deeplink';
export const CHECKOUT_PAGE = 'checkout page';
export const SUCCESS_SCREEN = 'success_screen';
export const PACKAGE_VIEW = 'package view';
export const __PRODUCT_TYPE_MAPPING = {
    highlight: 'FA',
    btt: 'BTT',
    autoboost: 'AUTOBOOST',
    spotlight: 'SPOTLIGHT'
};

export const __FLASH_SALE_MAPPING = {
    SALE_ENDED: 'SALE_ENDED',
    SALE_STARTS_SOON: 'SALE_STARTS_SOON',
    SALE_RUNNING: 'SALE_RUNNING'
};
